// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"9d777584962b32b1","741":"96802c5ae7ce4ab6"}[chunkId] + ".js";
};